module.exports = __webpack_public_path__ + "static/img/ent-detail-4.0f72edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-4.jpg
// module id = 9bgs
// module chunks = 52